//var $ = jQuery;
//import {debounce} from '../utils/utilities.js';




// Applies height onto the timeline.
function applyTimlineHeight(timelineHeight, numOfActiveItems, container) {

  // Creating a variable to keep track of where the for loop will end.
  var finalItemNumber = 0;

  // If we are at the end of the timeline.
  if(numOfActiveItems + 3 >= container.children().length) {

    // Only show the number of remaining items.
    finalItemNumber = container.children().length;

    // Disable the timline expand button.
    jQuery('#timeline__expand-button').attr('state', 'disabled');

    // Hide the fade at the end of the timeline.
    container.attr('hide-fade', '');
  }

  // If we are not at the end of the timeline.
  else {

    // Determine how many more items we are going to show.
    finalItemNumber = numOfActiveItems + 3;
  }

  // Cycling through each of the newly active items.
  for(var i = numOfActiveItems; i < finalItemNumber; i++) {

    // Caching the item element.
    var item = container.children()[i];

    // Adding the item height to the overall height of the timeline.
    timelineHeight += jQuery(item).outerHeight(true);

    // Adding up how many items are active.
    numOfActiveItems++;
  }

  // Applying the new inline styles height.
  container.css('height', timelineHeight+'px').attr('data-active-items', numOfActiveItems);
}

// The initialization function for the expanding functionality.
function expandTimeline() {

  // Checking if there is a timeline on the page before running any scripts.
  if(jQuery('.timeline').length > 0) {

    // Caching the items container.
    var container = jQuery('#timeline__items');

    // Setting how many items are currently active.
    var numOfActiveItems = 0;

    // Setting the current height of the timeline.
    var timelineHeight = 0;

    // Checking if there are more than 3 timeline items.
    if(container.children().length > 3) {

      // Applying the height of the timeline for the first 3 items.
      applyTimlineHeight(timelineHeight, numOfActiveItems, container);
    }

    // Binding the expand button to a click event.
    jQuery('#timeline__expand-button').on('click', function(e) {

      // Caching the items container.
      var container = jQuery('#timeline__items');

      // Checking how many items are currently active.
      var numOfActiveItems = parseInt(container.attr('data-active-items'));

      // Getting the height of the timeline.
      timelineHeight = container.outerHeight();

      // Applying the height of the timeine to container up to 3 more items.
      applyTimlineHeight(timelineHeight, numOfActiveItems, container);

    });
  }
}

export { expandTimeline };
